export default "__VITE_ASSET__CEfdnzwp__"